<ng-container *ngIf="vm$ | async as vm">
    <div fxLayout="column">
        <div fxLayout="column" class="section-heading">
            <h2>News section</h2>
            <span>Latest updates on marine radioactivity from the IAEA Marine Environment Laboratories</span>
        </div>
        <div class="news-line"></div>
        <div class="news-item" *ngFor="let item of filterNewsLoadMore(vm.news)" fxLayout="column">
            <div class="date">
                <span>{{ item.updatedOn || item.creationDate | date : 'yyyy-MM-dd' }}</span>
            </div>
            <div class="title">
                {{ item.title }}
            </div>
            <div class="content excerpt" [innerHTML]="item.content | firstParagraph : 1"></div>
            <a class="read-more" routerLink="/home/news/{{ item.contentId }}">Read more</a>
            <div class="divider"></div>
        </div>
        <div fxLayout="row" class="load-all-wrapper2" fxLayoutAlign="center center">
            <a fxLayout="row" fxLayoutAlign="center center" (click)="loadAll()" class="load-all2" *ngIf="!loadMoreOn">Load older news</a>
        </div>
    </div>
</ng-container>
